<app-document-countries
  [name]="'Правила использования электросамоката'"
  [countries]="countries"
></app-document-countries>
